import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {  ConfirmationService, MessageService } from 'primeng/api';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import * as moment from 'moment';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.css'],
  providers: [ MessageService,ConfirmationService]
})

export class SmsComponent implements OnInit {

  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Update campaign'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/surveys/sms-edit/update',data.data.id]);
      }   
    },
 
    { field: 'id',  
    headerName: '', 
    minWidth:60,
    width:60,
    cellRenderer: params =>    {   
        if(typeof params.value == 'undefined')
          return '';
        if(params.data.status == 'NOT_SENT')
          return '';
        if(params.data.status != 'TO CONFIRM')
          return '';
        return '<a title="'+'Confirm campaign'+'" style="cursor:pointer;">Confirm</a>'; 
    },
    onCellClicked:function(params){ 
     
      if(params.data.status != 'TO CONFIRM')
        return;

        _this.confirmationService.confirm({
          message: 'Attention: do you confirm to send this campaign?',
          accept: () => {
            _this.apiService.confirmSMS({id:params.data.id}).subscribe(data => {
              _this.addSingle('success', 'Success', 'Confirmed');
              _this.load();
            });
          }
        });
    }   
  },
    { field: 'name',headerName: 'Name' },  
    { field: 'status',headerName: 'Status' },  
    { field: 'sm_to_send',headerName: 'sm to send' },  
    { field: 'sm_sent',headerName: 'sm sent' },  
    { field: 'date_send',headerName: 'Date sent', valueFormatter:( (data) => {
        if(!data.value) return '';
        moment(data.value).format('DD/MM/YYYY HH:mm');
     })
    },
    { field: 'survey_name',headerName: 'Survey' },  
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          if((params.data.status == 'SENT')||(params.data.status == 'SEND IN PROGRESS'))
            return '';
     
          return '<a title="'+'Delete sms campaign'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 
       
            _this.apiService.deleteSMS({id:params.data.id}).subscribe(data => {
            _this.addSingle('success', 'Success', 'Campaign deleted');
            _this.load();
          });
      }   
    },
  ];
  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }
  smslist: any[] = [];
  gridApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

 
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
    params.columnApi.applyColumnState({ state: this.defaultSortModel });
  }

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    private confirmationService: ConfirmationService
  ) { }


  
  ngOnInit(): void {
    _this=this;
    this.load();
   
  }

  load(){
    const params: any = {PageSize : 10000};
    this.apiService.get('surveys/smslistall',params).subscribe(data => {
      this.smslist=data.Result;
      });
  }
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

}
var _this;